import { Component, OnInit, ViewChild, Input, Output } from '@angular/core';
//Librerias para el campo de color
import { ColorPickerService, Cmyk } from 'ngx-color-picker';
import { ViewContainerRef } from '@angular/core';

//Enrutamiento
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
//Alertas
import swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
//Datalist
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';
//Formularios
import {NgForm} from '@angular/forms';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
//Ventana Modal
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
//Calendar
import { FullCalendarModule, CalendarComponent } from 'ng-fullcalendar';
import { Options } from 'fullcalendar';

//Acordeon
import {AccordionModule} from "ng2-accordion";

//Servicios
import { ConfigService } from '../../servicios/config/config.service';

import { KeyService } from '../../servicios/key.service';
import { ValidService } from '../../servicios/valid.service';
import { AgendamientoAppService } from '../../servicios/agendamiento-app/agendamiento-app.service';
import { PqrService } from '../../servicios/pqr/pqr.service';
import { UsuariosService } from '../../servicios/usuarios/usuarios.service';
import { RastreoService } from '../../servicios/rastreo/rastreo.service';
import { PerfilesService } from '../../servicios/perfiles/perfiles.service';

import { EventosJqueryService } from '../../servicios/eventos-jquery/eventos-jquery.service';
//configuración del idioma de los datapicker
import { defineLocale } from 'ngx-bootstrap/chronos';
import { esLocale } from 'ngx-bootstrap/locale';
defineLocale('es', esLocale);
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { SlicePipe } from '@angular/common';
import { element } from 'protractor';
import { getDate } from 'ngx-bootstrap/chronos/utils/date-getters';
// import { months } from '../../../assets/bower_components/moment/moment';

//Declaracion de variable global para usar jQuery
declare var $: any;

@Component({
  selector: 'app-calendarioAnual',
  templateUrl: './calendarioAnual.component.html',
  styleUrls: ['./calendarioAnual.component.css'],
  providers:[
      AgendamientoAppService,
      PqrService,
      UsuariosService,
      RastreoService,
      PerfilesService,
      EventosJqueryService,
      BsModalService,
  ]
})
export class CalendarioAnualComponent implements OnInit {
    toolData       :any;
    arryBloqueados = [];
    listpermisos         : any;
    //Calendar
    calendarOptions      : Options;
    @ViewChild(CalendarComponent) ucCalendar: CalendarComponent;

    //Parametro enviado desde tramiento pqr
    @Input() pqrid: string;
    identificadorAgenda  : any;

    //Variables para datatable
    order: string = 'info.name';
    reverse: boolean = false;
    sortedCollection: any[];
    data = [];

    formCalendario        : FormGroup;
    modalRef              : BsModalRef; //Ventana modal
    accion                : string = '' //Accion para Crear o Editar

    sindatos              = '';
    mensajeError          : any;
    mostrarpreloader      : boolean = false;
    mostrarcalendar       : boolean = true;
    mostrarBotonCrearAgenda : boolean = false;
    disabledTipo          : boolean = true;
    //Formulario Nueva Programacion
    inputCalendario = {
      calendarioanioid : '', fecha : '', dia : '', tipo : 'T', detalle : ''
    }
    //Constructor
    constructor(
        public vcRef                : ViewContainerRef,
        private cpService           : ColorPickerService,
        private _config             : ConfigService,
        private _valid              : ValidService,
        private _key                : KeyService,
        private _agendamiento       : AgendamientoAppService,
        private route               : ActivatedRoute,
        private router              : Router,
        private toastr              : ToastrService,
        private modalService        : BsModalService,
        private _pqr                : PqrService,
        private _usuarios           : UsuariosService,
        private _rastreo            : RastreoService,
        private _perfiles           : PerfilesService,
        private _evtjq              : EventosJqueryService,
        private esLocale            : BsLocaleService
    ){}

  ngOnInit()
  {
    this.cargarvalendarios();
    this._evtjq.eventoTeclaEnter();
    //Rastreo
    let opcionEnviar = 'Ingreso Calendario';
    this._rastreo.setRastreo(opcionEnviar, 'Calendario Anual').subscribe((resp)=>{
    });
    this.getPermisos();
    this.forminputCalendario();
  }

  cargarvalendarios(){
      let self = this;
    let dataAgenda = new Array();
    this._agendamiento.getRegistroCalendario().subscribe((res)=>{
        dataAgenda = res.data[1];
        for (let i = 0; i < 7; i++) {
            var vandera = 0;
            for (let j = 0; j < res.data[0].length; j++) {
                if(i == parseInt(res.data[0][j].diabloqueado)){
                  vandera = 1;
                }
            }
            if(vandera == 0){
                this.arryBloqueados.push(i);
            }
        }

        this.calendarOptions = {
            selectable: true,
            height :500,
            contenHeight :600,
            editable : true,
            eventLimit : false,
            header : {
                left : 'prev,next, today',
                center : 'title',
                right : 'month, agendaWeek, agendaDay'
            },
            events : [],
            businessHours: [
            {
                dow : this.arryBloqueados, // Monday, Tuesday, Wednesday
                start: '00:00', // 8am
                end: '23:59',// 6pm
                rendering :'background',
                editable : false,
            }
            ]
            ,eventRender: function eventRider(info){
                $(info.el).tooltip({title:info.event.title});
            }
        };
        setTimeout(function(){
            for(let i in dataAgenda){
                self.data.push({
                    calendarioanioid: dataAgenda[i].calendarioanioid,
                    detalle         : dataAgenda[i].detalle,
                    fecha           : dataAgenda[i].fecha,
                    tipo            : 'T',
                    title           : dataAgenda[i].detalle,
                    start           : dataAgenda[i].fecha,
                    end             : dataAgenda[i].fecha,
                },);
            }
            self.ucCalendar.eventsModel = self.data;
        },2000);
    });
  }


  DataTable(dta,titulo,Id){
    let self = this;

    $(document).ready(function(){
       let DTtblVariables =  $(Id).DataTable({
          dom: 'domBftrlp',
          pageLength: 6,
          language : {
            "lengthMenu": "Mostrar _MENU_ página",
            "zeroRecords": "No se ha encontrado ningún registro.",
            "info": "Mostrando página _PAGE_ de _PAGES_",
            "infoEmpty": "Registros no disponibles.",
            "search"   : "",
            searchPlaceholder: "Buscar",
            "loadingRecords": "Cargando...",
            "processing":     "Procesando...",
            "paginate": {
              "first":      "Primero",
              "last":       "Último",
              "next":       "Siguiente",
              "previous":   "Anterior"
            },
            "infoFiltered": "(_MAX_ Registros filtrados en total)"
        },
        destroy: true,
        data: dta,
        columns:[
            {defaultContent: ''}
            ,{data: '1'}
            ,{data: '2'}
            ,{data: '3'}
            ,{data: '4'}
        ],
        columnDefs: [
            {
                targets: [0],
                className: 'text-center'
            },
            {width: '1%', targets: [0]},
            {width: '1%', targets: [4]},
        ],

        buttons: [
          {
              extend: 'copy', className: 'copyButton', text: 'Copiar',
              title: titulo,
              exportOptions: {
                  columns: [':visible :not(:first-child)']
              }
          },
          {
              extend: 'excel', className: 'excelButton', text: 'Excel',
              title: titulo,
              exportOptions: {
                  columns: [':visible :not(:first-child)']
              }
          },
          {
              extend: 'print', className: 'printButton', text: 'Imprimir',
              title: titulo,
              exportOptions: {
                  columns: [':visible :not(:first-child)']
              }
          },
        ],

        createdRow: function(row, data, index){
            $(row).on("click",".eliminar", function(e){
                e.preventDefault();
                var id = $(this).attr('value');
                self.enviarEliminar(id,data[1]);
            });
        },

      });
    });
  }

  getPermisos()
  {
    this._perfiles.getPermisosUsuariosFull().subscribe((resp)=>{
        if (resp.data) {
            this.listpermisos = resp.data;
        }
        this.getCalendario();
    });
  }

  //mojinet : esto esta pendiente (sirve cuando se arrastra el evento)
  eventDrop(e)
  {
    var fecha_ini = e.event.start._d;
    fecha_ini.setDate(fecha_ini.getDate());
    fecha_ini = fecha_ini.toISOString();

    this.formCalendario.value.fecha = fecha_ini.replace(/T00:00:00.000Z/g, "");
    const fecha = new Date(this.formCalendario.value.fecha);
    let bloqueo = this.arryBloqueados.includes(fecha.getUTCDay());

    if(bloqueo == false){
        this.ucCalendar.eventsModel = [];
        this.ucCalendar.eventsModel = this.data;
        this.toastr.info('Dia Bloqueado', '', { timeOut: 1500 });
        return;
    }else{
        this.formCalendario.value.calendarioanioid = e.event.calendarioanioid;
        this.formCalendario.value.detalle = e.event.detalle,
        this.enviaModificar(0);
    }
  }

  public onEventLog(event: string, data: any): void {
      console.log(event, data);
  }


  /**
   * Función para obtener el listado del Agendamiento de la app
   */
  getCalendario()
  {
        let calendario_borrar =  this.listpermisos.configuracion_gestionincidencias_calendario_borrar;
        this.accion = 'Editar';
        this._agendamiento.getRegistroCalendario().subscribe((res)=>{
        var filas = [];
        $.each(res.data[0], function(){
            var elimina = '';
            if(calendario_borrar == true){
                elimina ='<button class="eliminar btn btn-danger btn-xs" value="'+this.calendarioanioid+'" title="Eliminar" style="margin-bottom:3px"><span class="glyphicon glyphicon-remove" ></span></button>';
            }
            var fila = {
                0 : elimina,
                1 : this.detalle,
                2 : this.tipo,
                3 : this.dia,
                4 : this.estado,
            };
            filas.push(fila);
        });

        var filas2 = [];
        $.each(res.data[1], function(){
            var elimina = '';
            if(calendario_borrar == true){
                elimina = '<button class="eliminar btn btn-danger btn-xs" value="'+this.calendarioanioid+'" title="Eliminar" style="margin-bottom:3px"><span class="glyphicon glyphicon-remove" ></span></button>';
            }
            var fila = {
                    0 : elimina,
                    1 : this.detalle,
                    2 : this.tipo,
                    3 : this.estado,
                    4 : this.fecha,
                };
                filas2.push(fila);
        });

        $("#dtlSemanal").DataTable().clear().draw();  //limpio datatable
        $("#dtfestivos").DataTable().clear().draw();  //limpio datatable
        this.DataTable(filas,'Calendario',"#dtlSemanal");
        this.DataTable(filas2,'Calendario',"#dtfestivos");
    });
  }

  showMessage(message: any) {
    console.log(message);
  }

  eventRender(e) {
    const html = `<ul>
      <li>${e.event.title}</li>
    </ul>`;
    e.element.html(html);
  }


  /**
   * Permite abril un modal para editar el agendamiento
   */
  eventClick(e, template:any)
  {
      let calendario_editar =  this.listpermisos.configuracion_gestionincidencias_calendario_editar;
      if(calendario_editar == true){
          this.disabledTipo = true;
          this.accion = 'Editar';
          this.inputCalendario.calendarioanioid = e.event.calendarioanioid;
          this.inputCalendario.detalle = e.event.detalle;
          this.inputCalendario.tipo    = e.event.tipo;
          this.inputCalendario.fecha   = e.event.fecha;
          this.modalRef = this.modalService.show(template, {backdrop:'static', keyboard:false, class: 'gray modal-md'});
      }else{
          this.toastr.error('No tiene permisos para editar', 'Error', { timeOut: 3000 });
      }
  }

  abrirModal(template:any, e,opcion)
  {
      if(opcion == 1){
          var fecha_ini = e.start ? e.start.format() : '';
          const fecha = new Date(fecha_ini);
          let bloqueo = this.arryBloqueados.includes(fecha.getUTCDay());

          if(bloqueo == false){
            this.toastr.info('Dia Bloqueado', '', { timeOut: 1500 });
            return;
          }
          this.inputCalendario.fecha      = fecha_ini;
      }

      this.accion = 'Crear';
      this.disabledTipo = false;

      this.inputCalendario.calendarioanioid = '';
      this.inputCalendario.detalle = '';
      this.inputCalendario.tipo    = 'T';
      this.modalRef = this.modalService.show(template, {backdrop:'static', keyboard:false, class: 'gray modal-md'});
  }


  rastreo(opcionEnviar){
      this._rastreo.setRastreo(opcionEnviar, 'Agendamiento').subscribe((resp)=>{
      });
  }

  colorRGB() {
      var num = Math.round(0xffffff * Math.random());
      var r = num >> 16;
      var g = num >> 8 & 255;
      var b = num & 255;
      var c = 1 >> 9;
      var A = 0.5;
      return 'rgba(' + r + ', ' + 47 + ', ' + b + ', '+ A +')';
  }

  submit(){
    if (!this.formCalendario.valid) {
        this._valid.touched(this.formCalendario);
        this.toastr.error('Campos obligatorios *', 'Error', { timeOut: 3000 });
    } else{
        if (this.formCalendario.value.calendarioanioid) {
            this.enviaModificar(1);
        } else {
            this.enviarCrear();
        }
    }
  }

  enviarCrear()
  {
    this._agendamiento.setCalendario(this.formCalendario.value).subscribe((resp) => {
      if (resp.error) {
          this.toastr.error('Ya existe un registro con el mismo codigo', 'Error', { timeOut: 3000 });
      } else {
            let opcionEnvio = 'Crea Calendario: Detalle : '+ this.inputCalendario.detalle;
            this._rastreo.setRastreo(opcionEnvio, 'Calendario').subscribe((resp)=>{
            });
            this.toastr.success(resp.message, '', { timeOut: 3000 });
            this.data.push({
                calendarioanioid: resp.data,
                detalle         : this.inputCalendario.detalle,
                fecha           : this.inputCalendario.fecha,
                tipo            : 'T',
                title           : this.inputCalendario.detalle,
                start           : this.inputCalendario.fecha,
                end             : this.inputCalendario.fecha,
            },);

            this.ucCalendar.eventsModel = [];
            if(this.formCalendario.value.tipo == 'P'){
                this.router.navigate(['main/enrutamientos/enrutamiento/calendarioanio'], { replaceUrl: true });
            }else{
                this.ucCalendar.eventsModel = this.data;
            }

            this.formCalendario.reset();
            this.modalRef.hide();
            this.getCalendario();
      }
    });
  }


  enviaModificar(id)
  {
    this._agendamiento.updateCalendario(this.formCalendario.value).subscribe((resp) => {
      if (resp.error) {
        this.toastr.error('Ya existe un registro conla misma fecha', 'Error', { timeOut: 3000 });
      } else {
        for (let i = 0; i < this.data.length; i++) {
            if(this.data[i].calendarioanioid == this.formCalendario.value.calendarioanioid){
                this.data[i].detalle = this.formCalendario.value.detalle;
                this.data[i].fecha   = this.formCalendario.value.fecha  ;
                this.data[i].title   = this.formCalendario.value.detalle;
                this.data[i].start   = this.formCalendario.value.fecha;
                this.data[i].end     = this.formCalendario.value.fecha;
            }
        }
        this.ucCalendar.eventsModel = [];
        this.ucCalendar.eventsModel = this.data;
        this.getCalendario();

        let opcionEnvio = 'Edtar Calendario : Detalle : '+ this.inputCalendario.detalle +  'Detalle : '+ this.inputCalendario.fecha;
        this._rastreo.setRastreo(opcionEnvio, 'Calendario').subscribe((resp)=>{
        });
        this.toastr.success(resp.message, '', { timeOut: 3000 });
        this.formCalendario.reset();
        if(id == 1){
            this.modalRef.hide();
        }
      }
    });
  }

  enviarEliminar(id,detalle)
  {
    swal({
        title: 'Esta seguro de eliminar el registro?',
        text: "",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
          this._agendamiento.destroyCalendario(id).subscribe((resp) => {
          if (resp.error) {
              this.toastr.error(resp.message, 'Error', { timeOut: 3000 });
          } else {
               let dataAux = [];
                for (let i = 0; i < this.data.length; i++) {
                    if(id != this.data[i].calendarioanioid){
                        dataAux.push(this.data[i]);
                    }
                }
                this.data = dataAux;
                this.ucCalendar.eventsModel = [];
                this.ucCalendar.eventsModel = this.data;

                let opcionEnvio = 'Elimina Calendario: : '+ id + ' Detalle: '+ detalle;
                this._rastreo.setRastreo(opcionEnvio, 'Calendario').subscribe((resp)=>{
                });
                this.toastr.success(resp.message, '', { timeOut: 3000 });
                this.getCalendario();
          }
        });
      }
    });
  }

  forminputCalendario()
  {

      let requeridoP;
      if (this.inputCalendario.tipo == 'P') {
          requeridoP =  [Validators.required];
      }

      let requeridoT;
      if (this.inputCalendario.tipo == 'T') {
          requeridoT =  [Validators.required];
      }

      this.formCalendario = new FormGroup({
          'calendarioanioid' : new FormControl(this.inputCalendario.calendarioanioid),
          'detalle'          : new FormControl(this.inputCalendario.detalle,[Validators.required, Validators.maxLength(120)]),
          'tipo'             : new FormControl(this.inputCalendario.tipo),
          'fecha'            : new FormControl(this.inputCalendario.fecha,requeridoT),
          'dia'              : new FormControl(this.inputCalendario.dia,requeridoP),
      });
  }
}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/main/calendarioAnual/calendarioAnual.component.ts